import { Outlet } from "react-router-dom";
import { ChartPie, CopyCheck, House, LayoutList, ShieldUser, Table, TableOfContents, User, UserCheck2, Users } from "lucide-react"
import { NavItem } from "@/components/layout/Menu/MenuGridIcon";
import { MenuRowIcon } from "@/components/layout/Menu/MenuRowIcon";
import { Roles } from "iasma-datatypes";

export function DirectoryMenu() {

	const navItems: NavItem[] = [
		{ label: 'Home', to: '/', icon: <House size={32} /> },
		{ label: 'Index', to: '/directory', icon: <LayoutList size={32} /> },
		{ label: 'Direktori', to: '/directory/iasma', icon: <Users size={32} /> },
		{ label: 'Personal', to: '/directory/personal', icon: <User size={32} /> },
		{ 
			label: 'Approval', to: '/directory/approval', icon: <UserCheck2 size={32} />,
			roles: [Roles.ADMIN_ANGKATAN, Roles.ADMIN_ALL]
		},
		{
			label: 'Security', to: '/directory/roles', icon: <ShieldUser size={32} />,
			roles: [Roles.ADMIN_ALL]
		},
		// { 
		// 	label: 'Duplicate', to: '/directory/duplicate', icon: <CopyCheck size={32} />,
		// 	roles: [Roles.ADMIN_ANGKATAN, Roles.ADMIN_ALL] 
		// },
		// { 
		// 	label: 'Statistik', to: '/directory/statistic', icon: <ChartPie size={32} />,
		// 	roles: [Roles.SUPER_SUPER] 
		// },
		// { 
		// 	label: 'test', to: '/directory/test', icon: <ShieldUser size={32} />,
		// 	roles: [Roles.SUPER_SUPER] 
		// },
	];

	return <>
		<MenuRowIcon menus={navItems} backpath="/" />
		<div className="p-2">
			<Outlet />
		</div>
	</>
}

export function DirectoryAdmin() {
	return <div>Directory Administration</div>
}